export enum DocumentType {
  CPF = 1,
  RG = 2,
  CNH = 3,
  SELF = 4,
  RG_FRONT = 5,
  RG_BACK = 6,
  MOTHER_NAME = 7,
  BUSINESS_LINE = 8,
  ESTABLISH_FORM = 9,
  FINANCIAL_STATISTIC = 10,
  CNH_BACK = 12,
  BORN_AT = 13,
  CNH_FRONT = 15,
  ADDRESS = 16,
  POWER_OF_ATTORNEY = 17,
  CUSTOM = 18,
  ADDRESS_PROOF = 19,
  CNPJ_PROOF = 20,
  SOCIAL_CONTRACT = 21,
  RNE = 22,
  RNE_FRONT = 23,
  RNE_BACK = 24,
  MINUTES_OF_ELECTION = 25,
  DIGITAL_CNH = 26,
  COMPANYANNUALBILLING = 27,
  CORPORATE_STRUCTURE = 31,
  MEMBERS_PROOF_ADDRESS = 32,
  PROOF_OF_INVOICING = 33,
  FINANCIAL_STATEMENT = 34,
  COMPANY_STATUTE = 35,
  DECLARATION_OF_BENEFICIARIES = 36,
  ID_WALL_SELFIE_DOCS = 55,
}

export enum DocumentUploadOrderAndType {
  SELFIE = 1,
  DOCUMENT_RG = 2,
  DOCUMENT_CHN = 3,
  SOCIAL_CONTRACT = 4,
  POWER_OF_ATTORNEY = 5,
  DIGITAL_CNH = 6,
  CUSTOM = 99,
  MINUTES_OF_ELECTION = 25,
  DOCUMENT_AND_SELF = 27,
  PROOF_OF_INVOICING = 33,
  COMPANY_STATUTE = 35,
  DECLARATION_OF_BENEFICIARIES = 36,
}
